import { modifier } from 'ember-modifier';
let DEFAULT_DELAY = 500;

// {{throttle-on 'input' this.someFunction delay=500}}
// delay is optional. default is 500 milliseconds
export default modifier(function throttleOn(
  element,
  [eventName, action],
  { delay = DEFAULT_DELAY },
) {
  let timeoutId = null;
  let handler = (e) => {
    if (timeoutId == null) {
      timeoutId = setTimeout(() => {
        action(e);
        timeoutId = null;
      }, delay);
    }
  };
  element.addEventListener(eventName, handler);

  return () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    element.removeEventListener(eventName, handler);
  };
});
